import React, { useEffect } from 'react';
import { makeStyles } from '@mui/styles';
import { Button } from '@mui/material';

const useStyles = makeStyles({
    root: {
        display: 'flex',
        flexDirection: 'column',
        alignItems: 'center',
        justifyContent: 'center',
        height: '100vh',
    },
    form: {
        display: 'flex',
        flexDirection: 'column',
        gap: '1rem',
    },
});

const HomePageComponent = () => {
    const classes = useStyles();
    const [isAdmin, setIsAdmin] = React.useState(false);
    const [userInformation, setUserInformation] = React.useState("");
    let scriptLoadInitiated = false;

    useEffect(() => {
        const fetchInitData = async () => {
            if (scriptLoadInitiated) {
              return;
            } 
            scriptLoadInitiated = true;
            try {
              const response = await fetch('/api/init');
              const data = await response.json();
              const { isAdminUser, Account} = data;
              
              setIsAdmin(isAdminUser);
              setUserInformation(Account?.name);
            } catch (error) {
              console.error('Error fetching data:', error);
            }
          };
      
          fetchInitData();
    }, []);

    const handleSubmit = (e) => {
        fetch('/api/toggle-user')
          .then(response => response.json())
          .then(data => {
            window.location.reload();
          })
          .catch(error => {
            console.error('Error:', error);
            // Handle the error in your UI
          });
    };

    return (
        <div className={classes.root}>
            <h1>Welcome, {userInformation} !</h1>
            {isAdmin && <Button variant="contained" color="primary" onClick={handleSubmit}>swith role</Button>}
        </div>
    );
};

export default HomePageComponent;